import { render, staticRenderFns } from "./ProcesosDetail.vue?vue&type=template&id=2b778446"
import script from "./ProcesosDetail.vue?vue&type=script&lang=js"
export * from "./ProcesosDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports